import script from "./DataProtectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProtectModal.vue?vue&type=script&setup=true&lang=ts"

import "./DataProtectModal.vue?vue&type=style&index=0&id=e20e7542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e20e7542"]])

export default __exports__